import uniq from 'lodash.uniq'

import { tabs } from 'modules/SlotsRoot/data/tabs'
import { Providers } from 'modules/SlotsRoot/types/configuration'
import { gameTypeDTO, ISlotDTO } from 'modules/SlotsRoot/types/interfaces/Slots/GameCatalog'
import { ISlotsGameType } from 'modules/SlotsRoot/types/interfaces/Slots/Slots'

import { uniqGameId } from './uniqGameId'

const excludeLiveSlotsToCasino = ['1301']

export const excludeSlotsForARS = [
  'vs20bnnzdice',
  'vs20bnnzdice_cv77',
  'vs20dhdice',
  'vs20dhdice_cv77',
  'vs20msdice',
  'vs20msdice_cv101',
  'vs20olympdice',
  'vs20olympdice_cv96',
  'vs20sugardice',
  'vs20sugardice_cv97',
]

export const providersWhiteList = [
  'amatic',
  'evolution',
  'spribe',
  'pragmaticplay',
  'pragmaticplaylive',
  'vivogaming',
  'xpg',
  'betsolutions',
  'spinomenal',
  'originalgames',
  'betsoft',
  'pgsoft',
  'endorphina',
  'yggdrasil',
  'spadegaming',
  'bgaming',
]

export const digitainProvidersBlackList = [
  'gameart',
  'atomic slot lab',
  'platipus',
  'gsport',
  'winfast',
  'pragmatic play',
  'pgsoft',
  'upgaming',
  'pg soft',
  'onlyplay',
]

export const providerReplacingNames: { [key: string]: string } = {
  evosw: 'evolution',
  pragmatic: 'pragmaticplay',
  xprogaming: 'xpg',
  upgaming: 'upgaming',
}

export const providerLiveReplacingNames: { [key: string]: string } = {
  pragmatic: 'pragmaticplaylive',
}

export const renameDigitainProvider = (prov: string) => {
  const renamedDigiProvider = prov?.toLowerCase() || ''
  return providerReplacingNames[renamedDigiProvider] || renamedDigiProvider
}

export const getSlotProviderName = (slot: ISlotDTO): string => {
  if (slot.integration === '08f21347' && slot.producer === 'pragmatic') {
    return slot.game_type && slot.game_type.includes('live-casino') && !excludeLiveSlotsToCasino.includes(slot.game_id)
      ? providerLiveReplacingNames[slot.producer]
      : providerReplacingNames[slot.producer]
  }

  if (slot.integration === Providers.digitain) {
    return renameDigitainProvider(slot.provider)
  }

  return providerReplacingNames[slot.producer] || slot.producer
}

export function getGameCatalogTab(slotId: string, dropAndWins?: boolean): string[] {
  // const additionalTabs: string[] = dropAndWins ? ['Drops & Wins'] : []

  const trueTab = Object.keys(tabs).reduce(
    (acc: string[], tab: string) =>
      tabs[tab].findIndex((item: string) => item === slotId) === -1 ? acc : [...acc, tab],
    [],
  )
  return uniq([...trueTab])
}

export const blackListGames = [uniqGameId(Providers.SoftGaming, 'spribe', 'aviator')]

const replaceGameTypeName: { [key in gameTypeDTO]: ISlotsGameType } = {
  slots: 'casino',
  'live-casino': 'live-casino',
}

export const getGameType = (item: ISlotDTO) => {
  const gameType = item.game_type?.[0]
  const replacedGameType = gameType ? replaceGameTypeName[gameType] : undefined

  if (!replacedGameType) return {}

  if (item.integration === Providers.digitain) {
    return {
      gameType: replacedGameType,
    }
  }

  return {}
}
